var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditTrails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 16.5C10 12.92 12.92 10 16.5 10C17.39 10 18.23 10.18 19 10.5V5H17V8H7V5H5V19H10.5C10.18 18.23 10 17.39 10 16.5Z",
    fill: "#49e2b5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19H5V5H7V8H17V5H19V10.5C19.75 10.81 20.42 11.26 21 11.82V5C21 3.9 20.1 3 19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11.82C11.27 20.42 10.81 19.75 10.5 19ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3Z",
    fill: "#49e2b5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3 18.9C20.7 18.2 21 17.4 21 16.5C21 14 19 12 16.5 12C14 12 12 14 12 16.5C12 19 14 21 16.5 21C17.4 21 18.2 20.7 18.9 20.3L21.6 23L23 21.6L20.3 18.9ZM16.5 19C15.1 19 14 17.9 14 16.5C14 15.1 15.1 14 16.5 14C17.9 14 19 15.1 19 16.5C19 17.9 17.9 19 16.5 19Z",
    fill: "#49e2b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrails);
export default __webpack_public_path__ + "static/media/audit-trails.d54df229.svg";
export { ForwardRef as ReactComponent };